// import AuthLayout from "../../components/";
import {
    Button,
    Col,
    Image,
    Layout,
    List,
    Row
} from "antd";
import {
    FaCheckCircle
} from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
import { useEffect } from "react";
// import router from "next/router";

function Homepage() {
    const navigate = useNavigate();

    const data1 = [
        {
            title: "Attach a logo to the portal.",
        },
        {
            title: "Create a referral code for users to self-enroll into a portal.",
        },
    ];
 useEffect(() => { window.scrollTo(0, 0); }, []);
    return (
        <>
            {/* <Helmet>
                <title>Preschool Management Solutions & Facility Consulting in NYC</title>
                <meta name="description" content="Access expert management solutions, facility consulting, & maintenance strategies for preschool in New York City to empower your early education program." />
                <meta property="og:title" content="Preschool Management Solutions & Facility Consulting in NYC" />
                <meta property="og:description" content="Access expert management solutions, facility consulting, & maintenance strategies for preschool in New York City to empower your early education program." />
            </Helmet> */}
            <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c1.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Non-Profit Organization Governance</h4>
                                        <p className="text-p-16">
                                            Duration:30 mins
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Prospective and Seasoned Board Members
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            Non-Profit Organization Governance 101 Topics covered in this lecture series clarify: What Directors do, How They Do It, and for Whom they work for. This lecture series also introduces current legal trends in Directors Liability, overviews the Legal Environment Directors are immersed in and provides best practices on new Directors Orientation practices. The failure (or alleged failure) of directors of non-profit corporations to fulfill their duties may expose them to liability to third parties, or to the corporation Directors should therefore be aware of protections that may be available against such liability in recent years, litigation against directors of many varieties of nonprofits has increased in frequency The demise of the charitable immunity exemption, that was previously available to many kinds of nonprofit corporations has increased the frequency of suits against directors and officers of public benefit and religious corporations., (Mutual benefit corporations and their directors have never enjoyed the protection of the charitable exemption.) Although many small nonprofit corporation boards face little or no practical liability risk, all directors need to understand the actions that may be taken to protect them against liability related to their service on a nonprofit corporation’s board. A nonprofit corporation director should understand what the corporation’s basic documents provide as to indemnification and insurance and know if there are any statutory exemptions or other legal provisions that may limit the director’s liability.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>


                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c2.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Non-Profit Organization Governance-Corporate Responsibilies</h4>
                                        <p className="text-p-16">
                                           Duration:30 mins
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            Non-Profit Organization Governance-Corporate Responsibilities 303 This lecture series covers the creation, operation and management of both standing and ad hoc committees as well as various auxiliary relationships and joint venture efforts. Concluding with a review of various sales tax and fundraising issues. The directors of a nonprofit corporation will frequently discharge their duties through committees composed , wholly or in part, by members of the board. The directors should understand what functions can be delegated to committees, what responsibilities the board has concerning committee activities and the degree to which directors can rely upon information provided by committees. The directors should also understand the difference between committees of directors and certain kinds of advisory or auxiliary boards or other bodies composed of non-directors. The board of a nonprofit corporation may decide that the corporation’s mission and goals would be served by engaging in an activity that does not easily fit within the corporation’s current structure. If such activity is one that is typically engaged in by nonprofit organizations, the board may establish a nonprofit subsidiary or affiliate. However, if the activity is one that will generate taxable income, or is typically conducted by for-profit rather than nonprofit organizations, the board may consider establishing a for-profit subsidiary, or entering into joint-venture arrangement with a for-profit entity. A director should understand the basic application of federal and local tax law to the corporation. This lecture outlines the principal federal income tax issues of the more common nonprofit corporation.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c3.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Non-Profit Organization Governance-Personal Liability</h4>
                                        <p className="text-p-16">
                                           Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Prospective and Seasoned Board Members
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            Non-Profit Organization Governance-Personal Liability 202 Key topics discussed in this lecture series focus on a Non-Profit Directors Personal Liability including D&O insurance as a Directors Duties and Rights come into play. Additionally how certain corporate expenditures may present a direct personal liability for the Director and finally many aspects of wading through certain corporate financial events should be handled to avoid personal liability, such as Bankruptcy. This lecture will cover the duties of a director under special circumstances such as: (1) disposition of unique property; (2) mergers, sales, or other change of control events; and (3) insolvency or bankruptcy.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                 <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c4.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Non-Profit Organization-General Responsibilies</h4>
                                        <p className="text-p-16">
                                           Duration:30 mins
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Prospective and Seasoned Board Members
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            Fulfillment of its mission and involve more of the nonprofit’s community in the nonprofit’s activities? If so, what are the legal implications of using volunteers? Most nonprofit corporations employ staff to assist in carrying out the mission and activities of the corporation. The nonprofit director should have a basic understanding of the legal risks relating to employees and the responsibilities of the corporation to its employees. Although small nonprofit corporations may rely solely on volunteers to accomplish their missions, most nonprofit corporations employ paid staff to carry out at least some of these activities. The size of the staff can vary from a single part-time employee in a small, grassroots organization to a staff of a hundred or a thousand full-time employees. All nonprofit corporations generally must comply with federal and state laws regarding employees, although some legal requirements may vary depending on the number of employees. Nonprofit corporations often have an employment relationship with the chief executive defined by a formal contract. Directors should be aware of the terms of that contract and the law applicable to that employment relationship. The board of directors may also approve policies and employment terms applicable to other employees. In addition, because a significant number of the lawsuits generally brought against nonprofit directors and officers involve employment-related matters, it is important for directors to have a basic understanding of the range of legal requirements and potential liabilities that may arise in connection with employees. This section will outline some of the considerations and general legal requirements for nonprofit corporations who hire employees. The law applying to activities on the Internet is still evolving. Lawmakers, regulators and judges across the country are in the process of determining how various laws written for the traditional economy fit the virtual world of the Internet. While this Section is designed to alert nonprofit corporation directors to some of the major legal implications of Internet activity, specific statements may become inaccurate, or less accurate, over time. (For instance, it can be expected that the IRS will make, and periodically revise, pronouncements on many of the topics discussed below.) Nonprofit boards should make sure that their corporation’s Internet activities are reviewed by legal counsel on a regular basis, to ensure compliance with changing legal standards.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>
            </Layout>
        </>
    );
}

export default Homepage;
